import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useStoreHydrationState, useStudentGateState } from '@/store/selectors'

const PUBLIC_STUDENT_PATHS = new Set(['/students', '/demo', '/students/manage', '/pretest', '/game-preview/adventure'])

export default function StudentGate({ children }: { children: ReactNode }) {
  const location = useLocation()
  const hydration = useStoreHydrationState()
  const { activeStudentId, hasAITeacherActive, hasAITeacherSession, hasPretestResult } = useStudentGateState()
  const isAITeacherRoute = location.pathname === '/progress'
    && new URLSearchParams(location.search).get('mode') === 'ai-teacher'
  const canRecoverAITeacher = isAITeacherRoute && (hasAITeacherActive || hasAITeacherSession)

  if (hydration.status === 'hydrating') return null
  if (hydration.status === 'failed') {
    return (
      <main className="grid min-h-screen place-items-center bg-slate-50 px-6">
        <section className="max-w-lg text-center" role="alert">
          <h1 className="text-2xl font-bold text-slate-900">无法读取学习档案</h1>
          <p className="mt-3 text-slate-600">数据库连接或档案恢复失败。系统没有把当前学生当作空档案处理。</p>
          <button
            className="mt-6 rounded-md bg-slate-900 px-5 py-3 font-semibold text-white"
            type="button"
            onClick={() => void hydration.retry()}
          >
            重试读取
          </button>
        </section>
      </main>
    )
  }

  if (!activeStudentId && !PUBLIC_STUDENT_PATHS.has(location.pathname) && !canRecoverAITeacher) {
    return <Navigate to="/students" replace state={{ from: location.pathname }} />
  }

  if (activeStudentId && !hasPretestResult && !PUBLIC_STUDENT_PATHS.has(location.pathname) && !canRecoverAITeacher) {
    return <Navigate to="/pretest" replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}
